import React, { useState, } from "react";

import {
  Pane,
  Paragraph,
  Combobox,
  Button,
  Badge,
  AddIcon,
  Tooltip,
  HelpIcon
} from 'evergreen-ui';

const NewCreatorBox = props => {
  // For new products with no creators, start in add mode
  const shouldStartInAddMode = props.editMode === "new" && (!props.productcreatorSet || props.productcreatorSet.length === 0);
  const [addmode, setAddmode] = useState(shouldStartInAddMode);
  const [stagedCreator, setStagedCreator] = useState(false);
  
  // Set default creator type to "Author" (usually ID 1) if available
  const defaultCreatorType = props.onixGlobalData?.onixcontributorcodes?.find(code => 
    code.description?.toLowerCase() === 'author' || code.id === 1
  ) || false;
  const [stagedCode, setStagedCode] = useState(defaultCreatorType);

  const formatArrForDropdown = (arr, field) => {
    if (!Array.isArray(arr)) {
      console.log('Warning: Expected array for dropdown but got:', arr);
      return [];
    }
    let newArr = arr.map(item => {
      if (!item || typeof item !== 'object') {
        console.log('Warning: Invalid item in dropdown array:', item);
        return null;
      }
      let newObj = Object.assign({}, item)
      newObj["label"] = `${item[field] || 'Unknown'} (${item.id || 'N/A'})`;
      return newObj;
    }).filter(Boolean); // Remove any null items
    return newArr;
  }

  // Check if data is available for creators and codes
  const hasCreators = Array.isArray(props.creators) && props.creators.length > 0;
  const hasCodes = props.onixGlobalData &&
                   Array.isArray(props.onixGlobalData.onixcontributorcodes) &&
                   props.onixGlobalData.onixcontributorcodes.length > 0;

  const handleAttachNewCreatorToProduct = () => {
    if (!stagedCreator || !stagedCode) {
      return; // Don't add if either field is not selected
    }
    props.handleUpdateCreatorStaged(undefined, stagedCreator, stagedCode);
    // Reset for next creator
    setStagedCreator(false);
    setStagedCode(defaultCreatorType); // Reset to default type
    // Keep in add mode if this is a new product with only one creator
    if (productcreatorSet.length > 0) {
      setAddmode(false);
    }
  }
  
  const handleCancelAdd = () => {
    setAddmode(false);
    setStagedCreator(false);
    setStagedCode(defaultCreatorType);
  }

  const canAddNew = props.editing && props.editMode === "new";
  const addNewPrompt = (props.productcreatorSet || []).length < 1 && props.editMode === "new";
  const productcreatorSet = Array.isArray(props.productcreatorSet) ? props.productcreatorSet : [];

  const editPrompt = props.newMode
    ? ""
    : "(There are no creators attached to this product. Edit this record to add one.)";

  return (
    <Pane >
      <Paragraph size={300} fontWeight="bold" color="#5e5e5e" marginBottom={8}>CREATORS</Paragraph>

      {props.productcreatorSet && (
        props.productcreatorSet.map(creator => {
          let deletable = props.royaltySet.filter(royalty => royalty.creator.id === creator.creator.id).length === 0
          let button = "";
          let creator_type = (<Badge>{creator.onixContributorCode.description}</Badge>);
          let creator_name = (<Paragraph size={300} marginRight={8}>{creator.creator.displayName}</Paragraph>);
          if (props.editing) {
            button =
              <Pane display="flex" alignItems="center">
                <Button size="small" disabled={!deletable} appearance="primary" intent="danger" onClick={e => props.handleDelete(creator.id)} marginLeft={8} marginTop={8}>Delete</Button>

                {!deletable && <Tooltip content={
                  <Paragraph color="white" size={300}>Can't delete creator associated with royalty.</Paragraph>}
                  border="default">
                    <HelpIcon size={14} marginTop={6} color="muted" marginLeft={4} />
                    </Tooltip>}
              </Pane>
          }
          return (
            <Pane key={`creator${creator.id}`} borderBottom="default" paddingBottom={8} marginBottom={8} display="flex" alignItems="center">
              {creator_name}
              {creator_type}
              {button}
            </Pane>
          )
        })
      )}
      {addNewPrompt && (
        <Pane>
          <Paragraph fontStyle="italic" size={300}>
            {editPrompt}
          </Paragraph>
        </Pane>
      )}

      {!hasCreators && props.editing && (
        <Paragraph fontStyle="italic" size={300} color="orange">
          No creators available. Please add creators in the Settings menu first.
        </Paragraph>
      )}

      {!addmode && (
        <Button iconBefore={AddIcon} onClick={e => setAddmode(!addmode)} disabled={!hasCreators || !hasCodes}>
          {productcreatorSet.length === 0 ? 'Add Creator' : 'Add Another Creator'}
        </Button>
      )}
      {addmode && (
        <Pane marginTop={8} display="flex" alignItems="center">
          <Pane >
            <Paragraph size={300} color="#667b7f">Creator Name</Paragraph>
            <Combobox
              items={formatArrForDropdown(props.creators || [], "displayName")}
              itemToString={item => (item ? item.label : '')}
              onChange={selected => setStagedCreator(selected)}
              selectedItem={stagedCreator}
              placeholder="Select a creator"
              marginBottom={8}
              width={150}
              height={20}
            />
          </Pane>
          <Pane marginX={8}>
            <Paragraph size={300} color="#667b7f">Creator Type</Paragraph>
            <Combobox
              items={formatArrForDropdown(props.onixGlobalData?.onixcontributorcodes || [], "description")}
              itemToString={item => (item ? item.label : '')}
              onChange={selected => setStagedCode(selected)}
              selectedItem={stagedCode}
              marginBottom={8}
              width={150}
              height={20}
            />
          </Pane>
          <Button 
            size="small" 
            marginTop={8} 
            iconBefore={AddIcon} 
            onClick={e => handleAttachNewCreatorToProduct()}
            disabled={!stagedCreator || !stagedCode}
          >
            Add
          </Button>
          {productcreatorSet.length > 0 && (
            <Button size="small" marginTop={8} marginLeft={4} onClick={e => handleCancelAdd()}>
              Cancel
            </Button>
          )}
        </Pane>
      )}
    </Pane>
  );
}

export default NewCreatorBox;
